<h1 mat-dialog-title>Browser Not Compatible</h1>
<div mat-dialog-content>
    <mat-icon>device_unknown</mat-icon>
    <p>
        Your browser is not supported.<br />
        Please note that some functionality might not work as expected.<br /><br />
        Your browser is<br>
        <strong>{{ deviceInfo?.browser }} {{ deviceInfo?.browser_version }}</strong><br><br>
        The minimum supported version is<br>
        <strong>{{ deviceInfo?.browser }} {{ browserMinVersion }}</strong>
    </p>
    <button matDialogClose mat-raised-button color="primary">Continue</button>
</div>